export const translationEnUs = {
  common: {
    continue: 'Continue',
    submit: 'Submit',
    back: 'Go Back',
    and: 'and',
    canadaLink: 'I am registering my {{appliance}} in Canada',
    //Error page
    error: {
      heading: "Sorry, something's not right.",
      description: "It looks like there's been a technical issue but we're working to fix it.",
      contactPrompt: 'Please try again later or call us to complete your registration:',
      phoneNumber: '+1 833-552-2314',
      tryAgain: 'Try Again',
    },
    loader: {
      header: 'Loading...',
      text: 'Please wait while we redirect you to the next page. If loading continues, call us on',
      phoneNumber: '+1 833-552-2314',
    },
    footer: {
      disclaimer:
        "Service plans are provided by Domestic & General USA Services LLC. However, in Florida and Washington it is Domestic & General USA Inc. 866-333-3134, 230 East Avenue, Norwalk, CT, 06855. Domestic & General's use of trademarks is with permission. The plans are service contracts and not insurance.",
      links: {
        applianceCareTermsAndConditions: {
          text: 'Appliance care service plan terms and conditions',
          href: 'https://prod.domesticgeneral.magnolia-platform.io/dam/jcr:42f4b575-10b0-4c30-8001-4d9763184ae0/DG-APP-CARE-COMBINED-v2309.pdf',
        },
        productSupport: {
          text: '{{clientName}} Product Support',
          href: 'https://www.{{clientName}}.com/owners.html',
        },
        termsOfUse: {
          text: 'Terms of Use',
          href: 'https://www.domesticandgeneral.com/us/terms-and-conditions',
        },
        domesticAndGeneralPrivacyNotice: {
          text: 'Domestic & General privacy notice',
          href: 'https://www.domesticandgeneral.com/us/security-privacy',
        },
        clientPrivacyNotice: {
          text: '{{clientName}} privacy notice',
          href: 'https://www.whirlpoolcorp.com/privacy-policy.html',
        },
        cookiesNotice: {
          text: 'Cookies notice',
          href: 'https://www.domesticandgeneral.com/us/cookies',
        },
      },
    },
  },
  modelSerialLanding: {
    heading: 'Register your {{appliance}} in a few simple steps',
    intro: 'Enter your model and serial number for a quick registration',
    modelNumber: {
      label: 'Model number',
      placeholder: 'Search for a model number',
      hint: 'For example {{example}}',
      noResults: 'No {{appliances}} found',
      errors: {
        required: 'Model number is required',
        invalid: 'Please enter a valid model number',
        maxLength: 'Model number is too long',
      },
    },
    serialNumber: {
      label: 'Serial number',
      placeholder: 'Enter a serial number',
      hint: 'For example {{example}}',
      errors: {
        required: 'Serial number is required',
        minLength: 'Serial number must be at least {{min}} characters',
        maxLength: 'Serial number must be at most {{max}} characters',
        invalid: 'Please enter a valid serial number',
      },
    },
    searchError: 'Please wait for the search to finish before continuing',
    giftMessage: 'Select cooktops qualify for a free gift with accurate model & serial numbers.',
    benefitsHeading: 'Why register your {{appliance}}?',
    faq: {
      heading: 'Your questions',
      intro: "We're always here to help.",
      registrationRequirements: {
        question: 'What do I need to register my {{appliance}}?',
        answer:
          "You'll need the model and serial numbers, the approximate purchase price, and the delivery date.",
      },
      numberLocation: {
        question: 'Where can I find my model and serial numbers?',
        answer:
          'You can locate your model and serial numbers on the {{appliance}}, within product documentation, or within information provided after your purchase.',
      },
    },
    protection: {
      header: 'Go beyond the standard warranty. Get additional protection with Appliance Care',
      section:
        "Your manufacturer's warranty is a great start, but an Appliance Care protection plan goes further to keep you covered:",
      body: "You can add Appliance Care as part of your registration journey — it's quick, easy, and gives you peace of mind.",
      benefits: [
        'Accidental damage protection — for drops, spills, and mishaps',
        'Unlimited repairs with no surprise costs',
        "Replacement {{appliance}} if yours can't be fixed",
      ],
      alt: 'Kitchen',
    },
    modelNumberLocation: {
      textLink: 'How to find your model number',
    },
    missingModelOrSerialNumber: {
      textLink: 'Missing your model or serial number?',
      callUs:
        "If your model or serial numbers aren't recognized or you don't have them to hand, call us at <phone/> for support.",
      phone: '+1 833-552-2314',
      productSupport:
        'You can locate your model and serial numbers on the {{appliance}}, within product documentation, or within information provided after your purchase.',
    },
  },
  //Appliance Details page
  applianceDetailsPage: {
    heading: 'What type of {{appliance}} are you registering?',
    subHeadingCategory: 'Select {{applianceArticle}} {{appliance}} category',
    subHeadingAppliance: 'Select {{applianceArticle}} {{appliance}} type',
    errors: {
      selectCategory: 'Please select {{applianceArticle}} {{appliance}} category',
      selectType: 'Please select {{applianceArticle}} {{appliance}} type',
    },
  },
  //Purchase Price page
  purchasePricePage: {
    heading: 'How much did your {{appliance}} cost?',
    headingWithApplianceDetails:
      'We have captured your {{appliance}} details. How much did it cost?',
    applianceLabel: '{{appliance}}',
    priceDescription:
      'This is an estimate of the price you paid in store or online, to the nearest dollar.',
    inputLabel: 'Purchase price',
    placeholder: '0,000.00',
    errors: {
      required: 'Price is required',
      invalid: 'Please enter a valid price',
      min: 'Please enter a purchase price',
      max: 'Please enter a value less than $1,000,000.00',
    },
  },
  //Arrival Date page
  arrivalDatePage: {
    heading: 'When was your {{appliance}} delivered?',
    description: 'Either from an online purchase or an in-store visit',
    label: 'Delivery date',
    errors: {
      required: 'Please select a delivery date',
      invalid: 'Please enter a valid delivery date',
    },
  },
  //personal details page
  personalDetailsPage: {
    heading: 'Please enter your details',
    merchandiseAddressHeading: 'Please tell us the address where the {{appliance}} is installed',
    description: 'This ensures your {{appliance}} is registered to the right person and location.',
    termsIntro: 'By continuing, you acknowledge and agree to the',
    termsOfUse: 'Terms of Use',
    privacyNoticeIntro: 'and acknowledge the privacy notice of',
    domesticAndGeneral: 'Domestic and General',
    validation: {
      firstName: {
        required: 'Please enter a first name',
        invalid: 'Please enter an alphabetical value',
      },
      lastName: {
        required: 'Please enter a last name',
        invalid: 'Please enter an alphabetical value',
      },
      email: {
        required: 'Please enter an email address',
        invalid: 'Please enter a valid email address',
      },
      phoneNumber: {
        required: 'Please enter a phone number',
        invalid: 'Please enter a valid phone number',
      },
      address: 'Please enter an address',
      city: {
        required: 'Please enter a city',
        invalid: 'Please enter a valid City',
      },
      zipCode: {
        required: 'Please enter a ZIP code',
        invalid: 'Please enter a valid Zip Code',
      },
      state: 'Please select a state',
      installAddressPoBox:
        "PO Boxes can't be used as an install address. Please enter the physical address where the {{appliance}} is installed.",
    },
    addressForm: {
      searchLabel: 'Address',
      searchPlaceholder: 'Type to search address',
      enterManually: 'Enter Address Manually',
      line1Label: 'Address line 1',
      line1Placeholder: 'Enter address line 1',
      line2Label: 'Address line 2 (Optional)',
      line2Placeholder: 'Address line 2 (apartment, suite, etc.)',
      stateLabel: 'State',
      statePlaceholder: 'Select a state',
      cityLabel: 'City',
      cityPlaceholder: 'Enter a city',
      zipCodeLabel: 'Zip code',
      zipCodePlaceholder: 'Enter a zip code',
      poBoxHint:
        "PO Box detected — this will be used for correspondence only. You'll add the {{appliance}}'s install address on the next screen.",
    },
    personalDetailsForm: {
      firstNameLabel: 'First name',
      firstNamePlaceholder: 'Enter first name',
      lastNameLabel: 'Last name',
      lastNamePlaceholder: 'Enter last name',
      sameAsInstallAddress: 'Same as where my {{appliance}} is installed',
      emailLabel: 'Email',
      emailPlaceholder: 'Enter email',
      phoneNumberLabel: 'Phone number',
      phoneNumberPlaceholder: 'Enter phone number',
    },
  },
  // Confirmation Page
  confirmationPage: {
    heading: "That's it, you're all set!",
    registrationConfirmed: "Registration confirmed. We'll send you a confirmation email shortly.",
    registrationAndProtectionConfirmed:
      "Registration and protection confirmed. We'll send you a confirmation email shortly.",
    applianceCareTerms:
      "Applicable taxes are calculated monthly. Your payment details are shown above. Your plan documents, which we’ve already sent to you, include a full breakdown of your payment and any applicable taxes. Charges will appear on your billing statement as 'D&G Svc Plan'.",
    applianceCareTermsLink: 'Appliance Care Terms & Conditions',
    upsellBanner: 'Get a discounted price on {{appliance}} care today - limited time only!',
    registerAnotherAppliance: 'Register another {{appliance}}',
    accessProductInformation: 'Access information and manuals about your product',
    accessProductDetails: 'Access product details',
    copied: 'Copied!',
    copyCode: 'Copy this code',
    registration: {
      panelTitle: 'Registration details',
      applianceLabel: '{{appliance}}',
      warrantyLengthLabel: 'Manufacturer warranty length',
      warrantyLengthValue: '{{months}} months',
      modelNumberLabel: 'Model number',
      serialNumberLabel: 'Serial number',
      purchaseDateLabel: 'Delivery date',
    },
    plan: {
      panelTitle: 'Plan details',
      applianceLabel: '{{appliance}}',
      planNumberLabel: 'Plan number',
      planStartDateLabel: 'Plan start date',
      monthlyPaymentLabel: 'Monthly Payment',
      monthlyPaymentFirstMonthsLabel: 'Monthly Payment (first {{months}} months)',
      monthlyPaymentAfterMonthsLabel: 'Monthly Payment (after {{months}} months)',
    },
    upsell: {
      protectAppliance:
        "Protect your {{applianceName}} before it's too late – only ${{amount}}/month!",
      reassurance: 'Secure peace of mind while this offer lasts.',
      bankAccountDiscount: '*Discount applies to payments made via Bank Account only.',
      checkout: 'Checkout now',
      discountOffer: '{{percentage}}% off for {{months}} months{{marker}}',
    },
  },
};
